import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input, OnChanges,
  OnDestroy,
  SimpleChanges
} from "@angular/core";
import { Router } from '@angular/router';
import { AppService } from "@irb/app.service";
import {IEvent, IrbSettingsEvents, IrbEditorsEvents} from "@irb-common/events";
import { Subscription } from "rxjs";
import { UtilityService } from "@irb/irb-common/services/utility.service";
import {MainMenuService} from "@irb-common/modules/main-menu/main-menu.service";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import {EditorModelService} from "@irb/irb-editors/editor-model/editor-model.service";

@Component({ standalone: false,
  selector: "irb-common-main-menu",
  styleUrls: ["./main-menu.component.scss"],
  templateUrl: "./main-menu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuComponent implements OnDestroy, OnChanges {
  static slotAEditorHasUnsavedChanges: boolean = false;
  static slotBEditorHasUnsavedChanges: boolean = false;
  static slotCEditorHasUnsavedChanges: boolean = false;
  private eventSubscription: Subscription;
  menuEnabled: boolean = true;
  private isGlobalTriggered = false

  @Input() menuconfig: any;
  @Input() menuData: any;

  constructor(private appService: AppService, private util: UtilityService, public router: Router,
              private menuService: MainMenuService, private cdr: ChangeDetectorRef, private iss: IrbSettingsService, private editorModelService: EditorModelService) {
    this.eventSubscription = this.appService.getEvents().subscribe((event: IEvent) => {
      switch (event.type) {
        case IrbEditorsEvents.IS_MODIFIED:
          if (event.data.slot === "A") {
            MainMenuComponent.slotAEditorHasUnsavedChanges = true;
          } else if (event.data.slot === "B") {
            MainMenuComponent.slotBEditorHasUnsavedChanges = true;
          } else if (event.data.slot === "C") {
            MainMenuComponent.slotCEditorHasUnsavedChanges = true;
          }
          break;
        case IrbEditorsEvents.IS_NOT_MODIFIED:
          if (event.data.slot === "A") {
            MainMenuComponent.slotAEditorHasUnsavedChanges = false;
          } else if (event.data.slot === "B") {
            MainMenuComponent.slotBEditorHasUnsavedChanges = false;
          } else if (event.data.slot === "C") {
            MainMenuComponent.slotCEditorHasUnsavedChanges = false;
          }
          break;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const userDetails = changes.menuconfig?.currentValue;

    if (!this.isGlobalTriggered && userDetails && !userDetails.isMMCAdmin && !userDetails.isModelProvider && userDetails.isShowAutoTrading) {
      this.isGlobalTriggered = true;
      const globalSettings = this.editorModelService.getGlobalSettings();
      if (globalSettings) {
        this.hideAutoRebalanceReport(globalSettings);
        this.isGlobalTriggered = false;
      } else {
        this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
          this.hideAutoRebalanceReport(globalSettings);
          this.editorModelService.setGlobalSettings(globalSettings);
          this.isGlobalTriggered = false;
        });
      }
    }
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }

  showGlobalSettingsDialog() {
    this.appService.fireEvent(IrbSettingsEvents.SHOW);
  }

  logOut() {
    this.appService.logOut();
  }

  hideAutoRebalanceReport(globalSettings: any) {
    const menu = this.menuService.getMenuData(this.menuconfig);
    if (!globalSettings.isAutoRebalanceEnabled && menu[1].items.length === 3) {
      if (menu[1].items[2].id === 'auto-rebalance-report') {
        menu[1].items.pop();
        this.menuData = menu;
        this.cdr.detectChanges();
      }
    }
  }
}
